import React from 'react';

const BusinessLayout = ({ children }) => (
  <div className="tp-business-layout" data-app-zone="business">
    {children}
  </div>
);

export default BusinessLayout;
